import { action, observable, computed } from 'mobx';
import { Project } from '~/models/project.model';
import { IEvent, IMinimalEvent } from '~/types/model.types';
import { set } from 'mobx';
export class ProjectStore {
    @observable projects: Record<string, Project> = {};
    @observable currentProjectId: string = null;

    @computed
    get currentProject() {
        return this.projects[this.currentProjectId];
    }

    @action
    load(project: IEvent) {
        this.projects[project._id] = new Project(project);
    }

    @action
    loadProjectsSummary(projects: IMinimalEvent[]) {
        projects.forEach(updatedProject => {
            const currentProject = this.projects[updatedProject._id] || {};
            this.projects[updatedProject._id] = {
                ...currentProject,
                ...updatedProject
            } as Project;
        });
    }

    @action.bound
    selectProject(projectId: string) {
        this.currentProjectId = projectId;
    }

    @action.bound
    updateCurrentProject(project: Partial<Project>) {
        set(this.currentProject, project);
    }
}
